module.exports = __webpack_public_path__ + "static/media/avatar.531db553.jpg";